module.exports = __webpack_public_path__ + "static/media/find myself moving on-01.9d7f05e7.png";